<template>
    <section class="mask-loading" v-if="show">
        <section></section>
        <div class="loader">
            <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    :color="'#ffffff'"
            />
        </div>
    </section>
</template>

<script>
import {AtomSpinner} from 'epic-spinners'

export default {
        name: "Loading",
        props: {
          show: {
            type: Boolean,
            default: false
          }
        },
        components: {AtomSpinner},
    }
</script>

<style scoped lang="scss" src="./style/loading.scss"></style>
